import { call, put, takeEvery } from 'redux-saga/effects';
import { getLeadsAffiliate, countAffiliates } from '../../../../Leads/Manage_retail/requests/get_leads_affiliate_request';
import { getAffiliatesRequestSuccess, getAffiliatesRequestFailure, countAffiliatesSuccess } from '../actions/get_affiliates.actions';
import { GET_AFFILIATES_REQUEST } from '../constants/get_affiliates.constants';
import { message_error } from '../../../../../components/Message';

function* getAffiliatesSagaRequest({ where, pagination: { pageSize, page } }) {
    const { result, options, error } = yield call(getLeadsAffiliate, where, pageSize, (page !== 0 ? page - 1 : page) * pageSize);
    if (result) {
        const amount = yield call(countAffiliates, where);
        yield put(countAffiliatesSuccess(amount));
        yield put(getAffiliatesRequestSuccess(options));
    } else {
        yield put(getAffiliatesRequestFailure(error));
        message_error(error);
    }
}

export default function* getAffiliatesSaga() {
    yield takeEvery(GET_AFFILIATES_REQUEST, getAffiliatesSagaRequest);
}



// WEBPACK FOOTER //
// ./src/modules/PlatformManagement/Manage_affiliates/redux/sagas/get_affiliates.saga.js